package us.laantech.common.ui

import androidx.compose.foundation.text.input.InputTransformation
import androidx.compose.foundation.text.input.OutputTransformation


val decimalInputTransformation = InputTransformation {
    val current = asCharSequence().toString()
    val filtered = current
        .filter { it.isDigit() || it == '.' }
        .let { s ->
            val firstDot = s.indexOf('.')
            if (firstDot == -1) s
            else s.take(firstDot + 1) + s.drop(firstDot + 1).filter { it.isDigit() }.take(2)
        }
    if (filtered != current) {
        replace(0, length, filtered)
    }
}


val twoDecimalOutputTransformation = OutputTransformation {
    val text = asCharSequence().toString()
    if (text.isEmpty()) return@OutputTransformation
    val dotIndex = text.indexOf('.')
    when {
        dotIndex == -1 -> {
            append(".00")
        }

        dotIndex == text.length - 1 -> {
            append("00")
        }

        dotIndex == text.length - 2 -> {
            append("0")
        }
    }
}